module.exports = __webpack_public_path__ + "static/media/d9.16431106.jpg";